var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route"},_vm._l((_vm.route),function(r,index){return _c('b-nav-item',{key:index,attrs:{"to":'/' + _vm.routeLink(index)}},[_c('span',{staticClass:"noLine",class:'hide' + index},[_vm._v("/")]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.routeTitle(r)))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }